package com.hyperether.goodjob.scenes.jobs.components

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.Card
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.SpanStyle
import androidx.compose.ui.text.buildAnnotatedString
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.withStyle
import com.hyperether.goodjob.Dp
import com.hyperether.goodjob.Sp
import com.hyperether.goodjob.resources.Res
import com.hyperether.goodjob.resources.no_information
import com.hyperether.goodjob.theme.DarkGrey
import com.hyperether.resources.stringResource

@Composable
fun JobDetailsView(
    title: String,
    firstDescriptionText: String,
    firstDetailText: String,
    secondDetailText: String,
    secondDescriptionText: String,
    thirdDetailText: String,
    thirdDescriptionText: String,
    lastDescriptionText: String = "",
    lastDetailText: String = ""
) {
    Card(
        modifier = Modifier
            .fillMaxWidth()
            .padding(start = Dp(16f), end = Dp(16f), top = Dp(12f)),
        shape = RoundedCornerShape(Dp(8f)),
        elevation = Dp(8f)
    ) {
        Column(modifier = Modifier.padding(Dp(16f))) {
            Text(
                text = title,
                fontWeight = FontWeight.W700,
                fontSize = Sp(16f)
            )
            if (firstDetailText.isNotEmpty()) {
                Text(
                    text = buildAnnotatedString {
                        withStyle(
                            style = SpanStyle(
                                fontWeight = FontWeight.W400,
                                color = DarkGrey
                            )
                        ) {
                            append(firstDescriptionText)
                        }
                        withStyle(
                            style = SpanStyle(
                                fontWeight = FontWeight.W400,
                                color = Color.Black
                            )
                        ) {
                            append(firstDetailText)
                        }
                    },
                    fontSize = Sp(14f)
                )
            }

            if (secondDetailText.isNotEmpty()) {
                Text(
                    text = buildAnnotatedString {
                        withStyle(
                            style = SpanStyle(
                                fontWeight = FontWeight.W400,
                                color = DarkGrey
                            )
                        ) {
                            append(secondDescriptionText)
                        }
                        withStyle(
                            style = SpanStyle(
                                fontWeight = FontWeight.W400,
                                color = Color.Black
                            )
                        ) {
                            append(secondDetailText)
                        }
                    },
                    fontSize = Sp(14f),
                )
            }

            if (thirdDetailText.isNotEmpty()) {
                Text(
                    text = buildAnnotatedString {
                        withStyle(
                            style = SpanStyle(
                                fontWeight = FontWeight.W400,
                                color = DarkGrey
                            )
                        ) {
                            append(thirdDescriptionText)
                        }
                        withStyle(
                            style = SpanStyle(
                                fontWeight = FontWeight.W400,
                                color = Color.Black
                            )
                        ) {
                            append(thirdDetailText)
                        }
                    },
                    fontSize = Sp(14f),
                )
            }

            if (lastDetailText.isNotEmpty()) {
                Text(
                    text = buildAnnotatedString {
                        withStyle(
                            style = SpanStyle(
                                fontWeight = FontWeight.W400,
                                color = DarkGrey
                            )
                        ) {
                            append(lastDescriptionText)
                        }
                        withStyle(
                            style = SpanStyle(
                                fontWeight = FontWeight.W400,
                                color = Color.Black
                            )
                        ) {
                            append(lastDetailText)
                        }
                    },
                    fontSize = Sp(14f),
                )
            }

            if (firstDetailText.isEmpty() && secondDetailText.isEmpty() && thirdDetailText.isEmpty() && lastDetailText.isEmpty()) {
                Text(
                    text = stringResource(Res.string.no_information),
                    fontWeight = FontWeight.W400,
                    fontSize = Sp(14f)
                )
            }
        }
    }
}